import { ItemType } from '../../../../enums/ItemType';
import { NodeType } from '../../../../enums/NodeType';
import { Role } from '../../../../enums/Role';
import {
  getInvalidItemDataReference,
  getItemType,
  getSchema
} from '../../../../utils';
import { GetPermissionFn } from '../types';

export const getItemActionsMenuPermission: GetPermissionFn = ({
  hasRole,
  workspace,
  data
}) => {
  if (!data) return { canView: false, canEdit: false };

  if (hasRole(Role.planningReadonly)) {
    return { canView: false, canEdit: false };
  }

  const itemSchema = getSchema(workspace.schemas, NodeType.Item);
  if (getInvalidItemDataReference(workspace, itemSchema, data) != null) {
    return { canView: true, canEdit: false };
  }

  return { canView: true, canEdit: true };
};
